<template>
  <div class="live-num" :class="{'live-num-simple': simple}" v-if="live">
    <div class="live-status" :class="[`live-status-${live.status}`]" v-if="!simple">
      <div class="live-status-icon"></div>
      <div class="live-status-title" v-if="live.status == 2">开播时间：{{startTime.pattern("MM月dd日 HH:mm")}}</div>
      <div class="live-status-title" v-else>{{live.statusText}}</div>
    </div>
    <div class="live-other">
      <div class="live-operate live-person" :style="{visibility: live.status == 2 ? 'hidden' : 'visible'}" v-if="countType > 0">
        <div class="live-hot-icon"></div>
        <component :is="componentName" v-bind="numberConfig" class="live-operate-text"></component>
      </div>
      <div class="live-operate" @click.stop="$emit('share')">
        <div class="icon-share live-operate-icon"></div>
      </div>
    </div>
  </div>
</template>

<script>

    import {getDate} from "../../common/tool";
    import {getNumConf} from "../../common/live";
    import CountByTotal from "./CountByTotal";
    import CountByMinute from "./CountByMinute";
    import CountByStep from "./CountByStep";

    export default {
        name: "LiveStatus",
        props: {
            live: Object,
            simple: Boolean
        },
        components: {
            CountByTotal,
            CountByMinute,
            CountByStep,
        },
        data() {
            return {

            }
        },
        computed: {
            startTime() {
                return this.live?.start_time ? getDate(this.live.start_time) : null;
            },
            endTime() {
                return this.live?.end_time ? getDate(this.live.end_time) : null;
            },
            countType() {
                let res = 0;
                const live = this.live;
                if(live && live.start_time && live.end_time) {
                    if(live.numberRange) {
                        res = 3;
                    } else if(live.numberSet) {
                        res = 2;
                    } else if(live.view_count > 0) {
                        res = 1;
                    }
                }
                return res;
            },
            componentName() {
                return ['CountByTotal', 'CountByMinute', 'CountByStep'][this.countType - 1];
            },
            numberConfig() {
                let res = null;
                const live = this.live
                const speed = live.speed ? live.speed.split(",").map(Number): undefined;
                switch (this.countType) {
                    case 1:
                        res = {
                            numsConfig: getNumConf(live.start_time, live.end_time, live.view_count, live.status, live.statusText),
                            speed,
                        };
                        break;
                    case 2:
                        res = {
                            config: live.numberSet,
                            start: live.start_time,
                            end: live.end_time,
                            speed,
                            status: live.status,
                            statusText: live.statusText
                        };
                        break;
                    case 3:
                        res = {
                            id: live.id,
                            startTime: live.start_time,
                            endTime: live.end_time,
                            updateSpeed: speed,
                            targetNum: +live.view_count,
                            targetPercent: live.numberRange
                        };
                        break;
                }
                return res;
            }
        },
    }
</script>

<style lang="less">

</style>
